import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { AuthComponent } from './auth/auth.component';
import { AuthGuard } from './auth/auth.guard';

import { CircuitsComponent } from './contents/circuits/circuits.component';
import { PointsComponent } from './contents/points/points.component';
import { TraductionsComponent } from './contents/traductions/traductions.component';

import { StepOneComponent } from './contents/create-circuit/step-one/step-one.component';
import { StepTwoComponent } from './contents/create-circuit/step-two/step-two.component';
import { StepThreeComponent } from './contents/create-circuit/step-three/step-three.component';
import { StepForComponent } from './contents/create-circuit/step-for/step-for.component';
import { StepFiveComponent } from './contents/create-circuit/step-five/step-five.component';

import { LanguesComponent } from './my-app/langues/langues.component';
import { PersonnalisationComponent } from './my-app/personnalisation/personnalisation.component';
import { UsersComponent } from './my-app/users/users.component';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent, canActivate: [AuthGuard]},
  { path: 'circuits', component: CircuitsComponent, canActivate: [AuthGuard]},
  { path: 'points', component: PointsComponent, canActivate: [AuthGuard]},
  { path: 'traductions', component: TraductionsComponent, canActivate: [AuthGuard]},
  { path: 'langues', component: LanguesComponent, canActivate: [AuthGuard]},
  { path: 'personnalisation', component: PersonnalisationComponent, canActivate: [AuthGuard]},
  { path: 'users', component: UsersComponent, canActivate: [AuthGuard]},
  { path: 'create-circuit-1', component: StepOneComponent, canActivate: [AuthGuard]},
  { path: 'create-circuit-2', component: StepTwoComponent, canActivate: [AuthGuard]},
  { path: 'create-circuit-3', component: StepThreeComponent, canActivate: [AuthGuard]},
  { path: 'create-circuit-4', component: StepForComponent, canActivate: [AuthGuard]},
  { path: 'create-circuit-5', component: StepFiveComponent, canActivate: [AuthGuard]},
  { path: 'login', component: AuthComponent },
  { path: '**', redirectTo: 'home'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
